import { createContext, useContext } from "react";
import type { LandingVariant } from "@/lib/experiment";

const ExperimentVariantContext = createContext<LandingVariant | null>(null);

type ExperimentVariantProviderProps = {
  value: LandingVariant;
  children: React.ReactNode;
};

export const ExperimentVariantProvider = ({
  value,
  children,
}: ExperimentVariantProviderProps) => {
  return (
    <ExperimentVariantContext.Provider value={value}>
      {children}
    </ExperimentVariantContext.Provider>
  );
};

export const useExperimentVariant = () => useContext(ExperimentVariantContext);

